export default __webpack_public_path__ + "static/media/Group1.9d04c0ac.svg";